/*
 * Complementary fallback engine for Phoenix Import.
 * -------------------------------------------------
 * Manual complementary products (Search & Discovery) render server-side and always
 * win. This only fills the slots manual didn't, from the collection pairing bank.
 *
 * Picks exclude: the product itself, its manual group, the manual picks already
 * shown, anything out of stock, and anything the RELATED block is already showing
 * (so the same item never appears twice on the page).
 *
 * Fails safe at every step: any error leaves the row manual-only (or hidden).
 */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-complementary-config]');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var wrapper = document.querySelector('[data-complementary-wrapper]');
  var grid = document.querySelector('[data-complementary-grid]');
  if (!grid) return;

  var need = (cfg.productsToShow || 4) - (cfg.manualShown || 0);
  if (need <= 0) return; // manual filled the row

  // Exclude by id: the product itself, its group members, the shown manual ids.
  var excluded = {};
  [].concat(cfg.groupIds || [], cfg.manualIds || [], [cfg.productId]).forEach(function (id) {
    if (id !== null && id !== undefined && id !== '') excluded[String(id)] = true;
  });

  // --- seeded RNG: stable per product per day, rotates daily ---
  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  var day = Math.floor(Date.now() / 86400000);
  var seed = (((Number(String(cfg.productId).slice(-7)) || 1) * 2654435761) + day) >>> 0;
  var rng = mulberry32(seed);
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rng() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  // --- lightweight fuzzy match (Dutch singular/plural & compounds) ---
  function tokens(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9\u00C0-\u024F]+/g, ' ')
      .split(' ')
      .filter(function (t) { return t.length >= 3; });
  }
  function scoreMatch(aTokens, bTokens) {
    if (!aTokens.length || !bTokens.length) return 0;
    var hits = 0;
    aTokens.forEach(function (ta) {
      for (var i = 0; i < bTokens.length; i++) {
        var tb = bTokens[i];
        if (ta === tb || ta.indexOf(tb) === 0 || tb.indexOf(ta) === 0) { hits++; break; }
      }
    });
    return hits / aTokens.length;
  }

  // --- read the related-products block so we never show the same item twice ---
  function relatedContainer() {
    return document.querySelector('product-recommendations.related-products')
        || document.querySelector('.related-products');
  }
  function collectRelatedHandles(container) {
    var set = {};
    if (!container) return set;
    var links = container.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var m = (links[i].getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (m) set[decodeURIComponent(m[1])] = true;
    }
    return set;
  }
  // Related loads on its own AJAX timer; wait briefly for it before we pick.
  function waitForRelated(maxMs) {
    return new Promise(function (resolve) {
      var container = relatedContainer();
      if (!container) { resolve({}); return; }
      var t0 = Date.now();
      (function poll() {
        var ready = container.querySelectorAll('a[href*="/products/"]').length > 0;
        if (ready || Date.now() - t0 > maxMs) resolve(collectRelatedHandles(container));
        else setTimeout(poll, 120);
      })();
    });
  }

  function reveal() {
    if (wrapper && wrapper.hasAttribute('hidden') && grid.children.length > 0) {
      wrapper.removeAttribute('hidden');
    }
  }

  function run(bank, relatedHandles) {
    var candidates = (cfg.collections || []).filter(function (c) { return bank[String(c.id)]; });
    if (!candidates.length) { reveal(); return; }

    var titleTokens = tokens(cfg.productTitle);
    var best = null, bestScore = -1;
    candidates.forEach(function (c) {
      var sc = scoreMatch(titleTokens, tokens(c.title));
      if (sc > bestScore) { bestScore = sc; best = c; }
    });
    if (bestScore <= 0) best = shuffle(candidates)[0]; // no real match -> random source

    var perLocale = bank[String(best.id)];
    var handles = (perLocale && (perLocale[cfg.locale] || perLocale.nl)) || [];
    if (handles.length < 3) { reveal(); return; }

    var queue = [handles[0], handles[0], handles[1], handles[2]].slice(0, need);
    var wantByHandle = {};
    var orderedHandles = [];
    queue.forEach(function (h) {
      wantByHandle[h] = (wantByHandle[h] || 0) + 1;
      if (orderedHandles.indexOf(h) === -1) orderedHandles.push(h);
    });

    Promise.all(orderedHandles.map(function (h) {
      return fetch(root + 'collections/' + h + '/products.json?limit=250')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return { handle: h, products: d.products || [] }; })
        .catch(function () { return { handle: h, products: [] }; });
    })).then(function (results) {
      var pool = {};
      results.forEach(function (res) { pool[res.handle] = res.products; });

      var chosen = [];
      orderedHandles.forEach(function (h) {
        var want = wantByHandle[h];
        var eligible = (pool[h] || []).filter(function (p) {
          if (!p || excluded[String(p.id)]) return false;
          if (relatedHandles[p.handle]) return false; // already shown in "related"
          // products.json has no product-level "available"; it lives on variants
          return (p.variants || []).some(function (v) { return v.available; });
        });
        shuffle(eligible).slice(0, want).forEach(function (p) {
          excluded[String(p.id)] = true; // block dupes across the other collections too
          chosen.push(p);
        });
      });

      if (!chosen.length) { reveal(); return; }

      return Promise.all(chosen.map(function (p) {
        return fetch(root + 'products/' + p.handle + '?view=card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        htmls.forEach(function (html) {
          if (!html || !html.trim()) return;
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.setAttribute('data-complementary-fallback', '');
          li.innerHTML = html.trim();
          grid.appendChild(li);
        });
        reveal();
      });
    }).catch(function () { reveal(); });
  }

  function start() {
    Promise.all([
      fetch(cfg.bankUrl).then(function (r) { return r.json(); }).catch(function () { return null; }),
      waitForRelated(2500)
    ]).then(function (res) {
      if (!res[0]) return; // bank unreachable: leave manual-only / hidden
      run(res[0], res[1] || {});
    });
  }

  // Lazy-load when the block nears the viewport, but only when the wrapper is
  // visible. With no manual products it starts hidden (display:none), and a hidden
  // element never reports as intersecting, so in that case run immediately.
  if (wrapper && wrapper.hasAttribute('hidden')) {
    start();
  } else if ('IntersectionObserver' in window && wrapper) {
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { obs.disconnect(); start(); }
      });
    }, { rootMargin: '600px' });
    io.observe(wrapper);
  } else {
    start();
  }
})();